import React from 'react'

export const Select = ({ currentSelected,setcurrentSelected }) => {


    const handleSelected = (select) => {
        setcurrentSelected(select)
      }


  return (
    <form >
        <select 
        onChange={(event) => handleSelected(event.target.value)}
        value={currentSelected}
        className="select"
        >

        <option value="all" >Todos los skins</option>
        <option value="destacado" >DESTACADOS</option>
        <option value="Pistol">Pistolas</option>
        <option value="Escopeta">Escopetas</option>
        <option value="Subfusil">Subfusiles</option>
        <option value="Rifle">Rifles</option>
        <option value="Guantes">Guantes</option>
        <option value="Cuchillo">Cuchillos</option>
        <option value="Coleccionable">Pins</option>
        <option value="Agente">Agentes</option>
        <option value="Pegatina">Pegatinas</option>
        <option value="Grafiti">Grafitis</option>
        <option value="Contenedor">Cajas/Capsulas</option>
        </select>
    </form>
  )
}
